import PriceService from '@/api/PriceService.js'
import Vue from 'vue'
export const priceModule = {
  namespaced: true,
  state: () => ({
    priceData: [],
    priceLoadStatus: 'request',
    paginationPriceStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationPriceStateParams.total /
        state.paginationPriceStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.priceData = [...data]
    },
    create(state, data) {
      state.priceData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.priceData.findIndex(
        (x) => x.vehicle_tariffs__id == data.id
      )
      Object.assign(state.priceData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.priceData.findIndex(
        (x) => x.vehicle_tariffs__id == id
      )
      state.priceData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationPriceStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.priceLoadStatus = 'request'
    },
    load_success(state) {
      state.priceLoadStatus = 'success'
    },
    load_error(state) {
      state.priceLoadStatus = 'error'
    }
  },
  actions: {
    getPriceAll({ commit }, params) {
      commit('load_request')
      PriceService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createPriceData({ commit }, createData) {
      PriceService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editPriceMultiple({ commit }, { id, dataEdit }) {
      PriceService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deletePriceData({ commit }, id) {
      // commit("load_request");
      PriceService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
